var _path, _path2, _path3, _path4, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.49,
    y: 413.56,
    width: 39.08,
    height: 10.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,434.79a1.7,1.7,0,0,1,0-.19v-.53c0-.49,0-1.16,0-2,0-1.79,0-4.35-.07-7.59l.12.12-39.08.08.2-.2h0v10.32l-.2-.2,27.85.09,8.22.06,2.22,0,.58,0a.67.67,0,0,1,.21,0h-.74l-2.18,0-8.17.05L140,435h-.19v-.19c0-1.66,0-3.36,0-5.09v-5.23h0l.2-.2,39.08.08h.12v.12c0,3.27,0,5.86-.07,7.66,0,.86,0,1.53,0,2,0,.2,0,.37,0,.5A1,1,0,0,1,179,434.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.67,308.25s0-.07,0-.2v-.56c0-.51,0-1.23,0-2.15,0-1.89,0-4.61-.06-8l.1.13-32.18.08c.07-.09-.17.21.16-.21h0v5.54c0,1.83,0,3.62,0,5.38l-.16-.2,22.94.09,6.77.06,1.84,0h.64s0,0-.15,0h-.45l-1.8,0-6.73.06-23.06.09h-.16V297.33h0c.33-.42.09-.12.17-.21l32.18.08h.1v.13c0,3.46,0,6.2-.05,8.11,0,.9,0,1.61,0,2.12,0,.22,0,.4,0,.54S192.68,308.26,192.67,308.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.88,442.2a1.78,1.78,0,0,1,0-.2l0-.56c0-.52,0-1.23,0-2.16,0-1.88,0-4.6-.07-8l.13.12-41.36.09.21-.21h0v5.56c0,1.82,0,3.62,0,5.38l-.2-.21,29.47.1,8.7.05,2.36,0,.61,0h0l-.59,0-2.31,0-8.65.06-29.62.09h-.21V431.26h0l.21-.21,41.36.08H451v.13c0,3.45-.06,6.19-.07,8.1q0,1.36,0,2.13l0,.53A1.23,1.23,0,0,1,450.88,442.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.49,431.26a1.07,1.07,0,0,1,0-.21c0-.16,0-.35,0-.58,0-.54,0-1.27,0-2.2,0-1.92-.05-4.62-.08-8l.15.15-24.85.06.21-.21h0v2.83c0,.95,0,1.87,0,2.79v5.31l-.2-.2,17.77.09,5.18.06,1.4,0,.5,0-.45,0-1.36,0-5.13.05-17.91.1h-.2v-8.3c0-.47,0-.94,0-1.41v-1.42h0c0,.05.4-.4.22-.21l24.85.06h.15v.15c0,3.37-.06,6.12-.08,8.06,0,.91,0,1.63,0,2.16A6.39,6.39,0,0,1,456.49,431.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.52,
    y: 214.32,
    width: 39.08,
    height: 10.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.08,235.55a.76.76,0,0,1,0-.19v-.53c0-.48,0-1.16,0-2,0-1.79,0-4.35-.06-7.59l.12.12-39.08.08.2-.2h0v5.24c0,1.72,0,3.42,0,5.08l-.19-.19,27.85.08,8.22.06,2.22,0h.61l-.56,0-2.18,0-8.18.06-28,.08h-.2V225.23h0l.2-.2,39.08.08h.12v.12c0,3.27-.05,5.86-.07,7.66q0,1.29,0,2c0,.21,0,.37,0,.51A.92.92,0,0,1,414.08,235.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.83,149.94s0-.07,0-.2,0-.33,0-.56c0-.52,0-1.23,0-2.16,0-1.88,0-4.6-.07-8l.12.12-41.36.09.21-.21h0v10.94l-.21-.21,29.48.1,8.7,0,2.35,0,.62,0h-.57l-2.31,0-8.65.06-29.62.09h-.21V139h0l.21-.22,41.36.09H453V139c0,3.45,0,6.19-.07,8.1q0,1.36,0,2.13c0,.22,0,.39,0,.53S452.84,149.94,452.83,149.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.44,139s0-.08,0-.21,0-.35,0-.58c0-.54,0-1.27,0-2.2,0-1.92-.05-4.62-.08-8l.15.15-24.85.06.21-.21h0v5.62c0,1.83,0,3.61,0,5.31l-.2-.2,17.78.09,5.18.06,1.39,0,.5,0-.45,0-1.35,0-5.14,0-17.91.1h-.2V139c0-1.7,0-3.48,0-5.31v-5.62h0l.21-.21,24.85.06h.15v.15c0,3.37-.06,6.11-.08,8.06,0,.91,0,1.63,0,2.16A6.39,6.39,0,0,1,458.44,139Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.75,302.56s0-.07,0-.2,0-.33,0-.56c0-.51,0-1.23,0-2.15,0-1.89,0-4.61-.06-8l.1.13-32.18.08c.07-.09-.17.21.16-.21h0v5.54c0,1.83,0,3.62,0,5.38l-.16-.2,22.94.09,6.77.06,1.83,0h.65s0,0-.15,0h-.46l-1.79,0-6.74.06-23.05.09h-.16V291.64h0c.33-.42.09-.12.17-.21l32.18.08h.1v.13c0,3.46,0,6.2-.05,8.11,0,.9,0,1.61,0,2.12v.54C444.76,302.51,444.76,302.57,444.75,302.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.35,
    y: 61.92,
    width: 95.73,
    height: 158.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.16,
    y: 61.92,
    width: 95.73,
    height: 158.46,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.24,
    y: 65.13,
    width: 87.58,
    height: 152.03,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.91,
    y: 84.89,
    width: 53.85,
    height: 112.52,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.91,157.59c-.12-10.51,9.33-20.77,19.74-22.24,5-.7,10.23.29,14.87-1.62,8.28-3.39,10.91-14.39,19.24-17.65l.38,81.33H258.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.45,
    y: 88.48,
    width: 36.14,
    height: 59.96,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.98,
    y: 88.48,
    width: 39.05,
    height: 59.96,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.98,
    y: 152.63,
    width: 39.05,
    height: 57.94,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.03 87.44 154.15 87.44 154.15 34.25 155.53 34.25 155.53 87.44 189 87.44 189 33.07 113.03 33.07 113.03 87.44",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.54,
    y: 88.48,
    width: 33.46,
    height: 59.96,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.54,
    y: 152.63,
    width: 33.46,
    height: 57.94,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.45,
    y: 152.63,
    width: 36.14,
    height: 57.94,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.03,
    y: 152.63,
    width: 41.12,
    height: 57.94,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.45,
    y: 211.61,
    width: 36.14,
    height: 52.21,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.54,
    y: 211.61,
    width: 33.46,
    height: 52.21,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.59 87.44 67.59 34.25 68.98 34.25 68.98 87.44 108.02 87.44 108.02 33.07 31.45 33.07 31.45 87.44 67.59 87.44",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.03,
    y: 211.61,
    width: 41.12,
    height: 52.21,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.98,
    y: 211.61,
    width: 39.05,
    height: 52.21,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.03,
    y: 88.48,
    width: 41.12,
    height: 59.96,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.52,45.12s0-.07,0-.2v-.56c0-.52,0-1.24,0-2.16,0-1.89,0-4.6-.06-8l.1.12-32.18.09c.07-.1-.17.21.16-.21h0v5.55c0,1.82,0,3.62,0,5.38l-.16-.21,22.94.1,6.77.05,1.83,0h.48l.17,0h-.61l-1.79,0-6.74.06-23,.09h-.16V34.19h0l.17-.22,32.18.09h.1v.13c0,3.45,0,6.19-.05,8.1,0,.91,0,1.62,0,2.12,0,.23,0,.4,0,.54S256.53,45.12,256.52,45.12Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.72,470.37c0,.14-101.52.26-226.71.26s-226.73-.12-226.73-.26,101.49-.26,226.73-.26S476.72,470.22,476.72,470.37Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chairs--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.33,426.48c-.09.12-14-10.21-31-23.06S78.57,380.06,78.65,380s14,10.2,31,23.06S140.42,426.37,140.33,426.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.34,427.68c-.09-.11,13.77-10.89,31-24.07s31.19-23.78,31.28-23.66-13.77,10.89-31,24.07S72.42,427.79,72.34,427.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.56 368.12 80.11 381.41 83.75 381.41 87.52 368.12 82.56 368.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.24,377.52C73,393.71,60.51,454.15,57.35,469.41a2.88,2.88,0,0,0,2.75,3.51h0a2.83,2.83,0,0,0,2.72-2.13l24.39-90.91a5,5,0,0,0-4.68-6.35H81A4.88,4.88,0,0,0,76.24,377.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.93 368.12 133.38 381.41 129.74 381.41 125.97 368.12 130.93 368.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.66,351c-7.1-13.17-15.54-53.38-19.26-66.21-.1-.36-.21-.71-.32-1.05a20.73,20.73,0,0,0-19.76-14H95.9a20.71,20.71,0,0,0-19.75,14l-.33,1.05c-3.71,12.83-12.16,53-19.25,66.21,0,0-9.46,5.57-6.76,10.9,2.61,5.13,26.9,8.77,56.8,7.81,29.91,1,54.2-2.68,56.8-7.81C166.11,356.57,156.66,351,156.66,351Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.66,351a18.17,18.17,0,0,1,2.34,1.59,19.19,19.19,0,0,1,2.56,2.32,9.13,9.13,0,0,1,2.33,4.08,4.69,4.69,0,0,1-.34,2.81A5.17,5.17,0,0,1,161.3,364a18.44,18.44,0,0,1-3.12,1.39c-1.12.41-2.3.76-3.53,1.08a112.16,112.16,0,0,1-17.16,2.7c-6.44.6-13.54.91-21.21.92-1.92,0-3.87,0-5.86,0s-4-.14-6,0q-6.15.16-12.7,0a188,188,0,0,1-27.39-2.28,70.31,70.31,0,0,1-7.11-1.58A30.34,30.34,0,0,1,53.67,365a11.82,11.82,0,0,1-3.26-1.91,3.74,3.74,0,0,1-1.06-1.67c-.05-.15-.12-.31-.16-.47l-.06-.49-.05-.49c0-.17,0-.33,0-.5a7.46,7.46,0,0,1,1.51-3.56,21.49,21.49,0,0,1,5.81-5.09l-.1.1a102.1,102.1,0,0,0,6-15.8c1.69-5.49,3.24-11.11,4.73-16.82,1.56-6,3-11.9,4.47-17.74q1.09-4.38,2.16-8.7c.75-2.87,1.42-5.72,2.35-8.52a20.72,20.72,0,0,1,11.65-12.18,22,22,0,0,1,8.2-1.63h19.94a33,33,0,0,1,3.85.15,21.46,21.46,0,0,1,7.23,2.13,21.18,21.18,0,0,1,5.86,4.36,20.41,20.41,0,0,1,3.88,5.89l.61,1.62c.17.55.35,1.09.49,1.64.3,1.09.6,2.16.87,3.23,1.12,4.28,2.11,8.41,3.08,12.34,3.82,15.74,7.14,28.42,9.91,37,1.35,4.32,2.63,7.59,3.54,9.8.45,1.1.88,1.89,1.12,2.45l.39.85s-.61-1.09-1.61-3.26-2.25-5.47-3.63-9.78c-2.84-8.61-6.21-21.29-10.08-37-1-3.93-2-8.05-3.11-12.32-.27-1.07-.57-2.14-.87-3.23-.15-.55-.32-1.08-.49-1.62s-.4-1-.61-1.58a19.77,19.77,0,0,0-3.81-5.76,20.62,20.62,0,0,0-12.82-6.33,29.83,29.83,0,0,0-3.8-.14H104c-5.32.17-11-.67-16.14,1.61a20.23,20.23,0,0,0-11.36,11.89c-.9,2.74-1.59,5.62-2.33,8.48s-1.43,5.77-2.16,8.69c-1.44,5.85-2.9,11.77-4.46,17.76-1.49,5.71-3,11.34-4.74,16.84a102.46,102.46,0,0,1-6,15.88l0,.06-.06,0A21.06,21.06,0,0,0,51,356.17a6.92,6.92,0,0,0-1.42,3.31c0,.15,0,.3,0,.44l.05.44,0,.44c0,.14.1.28.15.42a3.17,3.17,0,0,0,.92,1.46,11.16,11.16,0,0,0,3.12,1.82,28.11,28.11,0,0,0,3.45,1.19,67.65,67.65,0,0,0,7.06,1.58,188,188,0,0,0,27.31,2.31q6.53.14,12.68,0c2-.11,4.08,0,6.06,0s3.93.06,5.85.06c7.66,0,14.75-.29,21.18-.86a111.94,111.94,0,0,0,17.12-2.63c1.23-.31,2.41-.65,3.52-1a18.51,18.51,0,0,0,3.09-1.37,5,5,0,0,0,2.18-2,4.46,4.46,0,0,0,.34-2.69,9,9,0,0,0-2.25-4,20.26,20.26,0,0,0-2.51-2.34c-.73-.58-1.31-1-1.7-1.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,377.52c3.22,16.19,15.73,76.63,18.88,91.89a2.88,2.88,0,0,1-2.75,3.51h0a2.83,2.83,0,0,1-2.72-2.13L126,379.88a5,5,0,0,1,4.67-6.35h1.54A4.89,4.89,0,0,1,137,377.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.26,358.27a.66.66,0,0,1-.22.06l-.68.12-2.59.4c-2.25.34-5.51.77-9.56,1.23-8.09.92-19.31,1.81-31.73,2s-23.68-.33-31.79-1c-4.06-.32-7.34-.64-9.6-.91l-2.6-.31-.68-.1a.65.65,0,0,1-.23-.05h.24l.68,0,2.61.22c2.26.21,5.55.47,9.6.75,8.11.55,19.35,1,31.76.82s23.61-1,31.7-1.88c4.05-.41,7.32-.78,9.58-1.06l2.6-.31.68-.06A.58.58,0,0,1,152.26,358.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.92,353.65c-.77-1.92-3.88-2.4-6.43-2.52a412.63,412.63,0,0,0-71.61,2.76,4.51,4.51,0,0,0-1.93.54c-.53.35-.77,1-.31,1.45l-.11,1.19c23.6,5.19,48.68,4.11,73,1.55a15.17,15.17,0,0,0,5.32-1.21C145.38,356.61,146.49,355.06,145.92,353.65Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M426,426.48c-.08.12-14-10.21-31-23.06S364.22,380.06,364.3,380s14,10.2,31,23.06S426.07,426.37,426,426.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,427.68c-.09-.11,13.77-10.89,30.95-24.07s31.19-23.78,31.28-23.66-13.77,10.89-31,24.07S358.08,427.79,358,427.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.21 368.12 365.76 381.41 369.4 381.41 373.17 368.12 368.21 368.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.89,377.52c-3.23,16.19-15.73,76.63-18.89,91.89a2.88,2.88,0,0,0,2.76,3.51h0a2.83,2.83,0,0,0,2.71-2.13l24.39-90.91a5,5,0,0,0-4.68-6.35h-1.54A4.88,4.88,0,0,0,361.89,377.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.58 368.12 419.03 381.41 415.39 381.41 411.62 368.12 416.58 368.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.31,351c-7.1-13.17-15.54-53.38-19.26-66.21-.1-.36-.21-.71-.32-1.05a20.72,20.72,0,0,0-19.76-14H381.55a20.71,20.71,0,0,0-19.75,14c-.11.34-.22.69-.32,1.05-3.72,12.83-12.17,53-19.26,66.21,0,0-9.46,5.57-6.76,10.9,2.61,5.13,26.9,8.77,56.8,7.81,29.91,1,54.2-2.68,56.8-7.81C451.77,356.57,442.31,351,442.31,351Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.31,351a18.17,18.17,0,0,1,2.34,1.59,19.19,19.19,0,0,1,2.56,2.32,9,9,0,0,1,2.33,4.08,4.76,4.76,0,0,1-.33,2.81A5.25,5.25,0,0,1,447,364a18.09,18.09,0,0,1-3.12,1.39c-1.11.41-2.3.76-3.53,1.08a112.16,112.16,0,0,1-17.16,2.7c-6.43.6-13.54.91-21.21.92-1.92,0-3.87,0-5.86,0s-4-.14-6,0q-6.15.16-12.7,0a188,188,0,0,1-27.39-2.28,70.31,70.31,0,0,1-7.11-1.58,30.34,30.34,0,0,1-3.51-1.21,12,12,0,0,1-3.26-1.91,3.64,3.64,0,0,1-1.05-1.67,3.75,3.75,0,0,1-.17-.47l-.06-.49,0-.49c0-.17,0-.33,0-.5a7.46,7.46,0,0,1,1.51-3.56,21.64,21.64,0,0,1,5.81-5.09l-.1.1a102.13,102.13,0,0,0,6-15.8c1.69-5.49,3.24-11.11,4.72-16.82,1.56-6,3-11.9,4.47-17.74q1.1-4.38,2.16-8.7c.75-2.87,1.43-5.72,2.35-8.52a20.72,20.72,0,0,1,11.65-12.18,22,22,0,0,1,8.2-1.63h19.95a33.13,33.13,0,0,1,3.85.15,21.47,21.47,0,0,1,7.22,2.13,21.18,21.18,0,0,1,5.86,4.36A20.41,20.41,0,0,1,422.3,282l.61,1.62c.17.55.35,1.09.49,1.64.3,1.09.61,2.16.88,3.23,1.11,4.28,2.11,8.41,3.07,12.34,3.82,15.74,7.14,28.42,9.91,37,1.35,4.32,2.63,7.59,3.54,9.8.45,1.1.88,1.89,1.12,2.45l.39.85s-.61-1.09-1.61-3.26-2.25-5.47-3.63-9.78c-2.84-8.61-6.21-21.29-10.08-37-1-3.93-2-8.05-3.1-12.32-.28-1.07-.58-2.14-.88-3.23-.15-.55-.32-1.08-.49-1.62l-.6-1.58a20,20,0,0,0-3.82-5.76,20.56,20.56,0,0,0-12.81-6.33,29.9,29.9,0,0,0-3.8-.14H389.67c-5.32.17-11-.67-16.14,1.61a20.23,20.23,0,0,0-11.36,11.89c-.9,2.74-1.59,5.62-2.33,8.48s-1.43,5.77-2.16,8.69c-1.44,5.85-2.9,11.77-4.46,17.76-1.49,5.71-3,11.34-4.74,16.84a102.46,102.46,0,0,1-6,15.88l0,.06-.06,0a21.06,21.06,0,0,0-5.66,4.95,6.91,6.91,0,0,0-1.41,3.31c0,.15,0,.3,0,.44l0,.44.05.44c0,.14.1.28.15.42a3.17,3.17,0,0,0,.92,1.46,11.16,11.16,0,0,0,3.12,1.82,28.11,28.11,0,0,0,3.45,1.19,67.65,67.65,0,0,0,7.06,1.58,188,188,0,0,0,27.31,2.31q6.53.14,12.68,0c2.05-.11,4.08,0,6.06,0s3.93.06,5.85.06c7.66,0,14.76-.29,21.18-.86a111.94,111.94,0,0,0,17.12-2.63c1.24-.31,2.41-.65,3.52-1a18.51,18.51,0,0,0,3.09-1.37,5,5,0,0,0,2.18-2,4.55,4.55,0,0,0,.35-2.69,9,9,0,0,0-2.26-4,19.58,19.58,0,0,0-2.51-2.34c-.73-.58-1.31-1-1.7-1.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.64,377.52c3.22,16.19,15.73,76.63,18.89,91.89a2.89,2.89,0,0,1-2.76,3.51h0a2.81,2.81,0,0,1-2.71-2.13l-24.39-90.91a5,5,0,0,1,4.67-6.35h1.55A4.89,4.89,0,0,1,422.64,377.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.91,358.27a.66.66,0,0,1-.22.06l-.67.12-2.59.4c-2.25.34-5.52.77-9.57,1.23-8.08.92-19.31,1.81-31.73,2s-23.68-.33-31.79-1c-4.06-.32-7.34-.64-9.6-.91l-2.6-.31-.68-.1c-.15,0-.23,0-.22-.05h.23l.68,0,2.61.22c2.27.21,5.55.47,9.6.75,8.12.55,19.35,1,31.76.82s23.62-1,31.71-1.88c4-.41,7.31-.78,9.57-1.06l2.6-.31.68-.06A.58.58,0,0,1,437.91,358.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M431.57,353.65c-.77-1.92-3.88-2.4-6.43-2.52a412.63,412.63,0,0,0-71.61,2.76,4.51,4.51,0,0,0-1.93.54c-.53.35-.77,1-.31,1.45l-.11,1.19c23.61,5.19,48.68,4.11,73,1.55a15.17,15.17,0,0,0,5.32-1.21C431,356.61,432.14,355.06,431.57,353.65Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 414.67,
    cy: 76.23,
    r: 35.11,
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.78,
    cy: 76.23,
    r: 31.15,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.93,76.23s0-.18-.05-.51-.05-.84-.1-1.48l-.06-1.09c0-.39-.13-.83-.2-1.3a22.82,22.82,0,0,0-.65-3.21,29.63,29.63,0,0,0-3.45-8.26A31.14,31.14,0,0,0,420.5,45.81a28.16,28.16,0,0,0-3.92-.46c-.67,0-1.34-.08-2-.07l-2.05.1c-.34,0-.69,0-1,.07l-1,.16c-.69.11-1.39.19-2.09.34a32.74,32.74,0,0,0-4.12,1.21,31.94,31.94,0,0,0-4,1.77c-.65.36-1.28.77-1.92,1.15-.32.21-.66.38-1,.61l-.91.68a34,34,0,0,0-3.51,3,34.84,34.84,0,0,0-3,3.59l-.71,1-.63,1-.62,1a8.36,8.36,0,0,0-.58,1.06c-.34.72-.69,1.45-1.05,2.18s-.55,1.53-.84,2.29a33.18,33.18,0,0,0-1.59,9.76A32.81,32.81,0,0,0,385.44,86l.84,2.3,1.05,2.18a6.69,6.69,0,0,0,.58,1.05l.62,1,.62,1,.72,1a34.84,34.84,0,0,0,3,3.59,34,34,0,0,0,3.51,3l.91.68c.3.23.64.4.95.61.65.38,1.28.79,1.93,1.15a31.94,31.94,0,0,0,4,1.77,32.74,32.74,0,0,0,4.12,1.21c.7.15,1.4.23,2.09.34l1,.16c.34,0,.69,0,1,.07l2.05.1c.68,0,1.35,0,2-.07a28,28,0,0,0,3.92-.46,30.56,30.56,0,0,0,13-5.78,30.89,30.89,0,0,0,7.89-8.79,29.63,29.63,0,0,0,3.45-8.26,22.82,22.82,0,0,0,.65-3.21c.07-.47.16-.91.2-1.3l.06-1.09c.05-.64.08-1.13.1-1.48a4.93,4.93,0,0,1,.05-.5v.5c0,.35,0,.84-.06,1.48,0,.33,0,.7,0,1.1s-.12.83-.18,1.3a23.75,23.75,0,0,1-.61,3.24,29.7,29.7,0,0,1-3.41,8.34A31.26,31.26,0,0,1,420.56,107a28.38,28.38,0,0,1-4,.47c-.67,0-1.35.09-2,.08l-2.07-.1c-.35,0-.7,0-1.05-.07l-1.05-.15c-.69-.12-1.4-.2-2.11-.34a36,36,0,0,1-4.18-1.22,32.72,32.72,0,0,1-4.09-1.79c-.66-.36-1.3-.78-2-1.17-.32-.2-.66-.38-1-.61l-.92-.69a33.66,33.66,0,0,1-3.56-3,34.71,34.71,0,0,1-3.08-3.63l-.72-1-.63-1-.63-1a9.32,9.32,0,0,1-.59-1.07l-1.06-2.22c-.29-.77-.57-1.54-.86-2.32a33.81,33.81,0,0,1-1.62-9.9A33.69,33.69,0,0,1,385,66.33c.29-.78.57-1.56.86-2.33s.71-1.47,1.06-2.21a8.55,8.55,0,0,1,.59-1.07l.63-1,.63-1,.72-1A28.84,28.84,0,0,1,396.16,51l.93-.69a10.59,10.59,0,0,1,1-.61c.65-.39,1.29-.81,1.95-1.17a32.72,32.72,0,0,1,4.09-1.79,36,36,0,0,1,4.18-1.22c.71-.14,1.41-.22,2.11-.33l1.05-.16c.35,0,.7,0,1.05-.07l2.07-.1c.69,0,1.37.06,2,.08a28.38,28.38,0,0,1,4,.47,31.26,31.26,0,0,1,21.07,14.81A29.59,29.59,0,0,1,445,68.6a23.75,23.75,0,0,1,.61,3.24c.06.47.14.9.18,1.3s0,.77,0,1.1c0,.64,0,1.13.06,1.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.3,75.35a8,8,0,0,1-1.26.36l-3.47.83c-2.95.68-7,1.6-11.6,2.6l-.26.06V78c0-4.89,0-9.3.06-12.5,0-1.54.05-2.82.07-3.79a9.76,9.76,0,0,1,.08-1.39,8.69,8.69,0,0,1,.09,1.39c0,1,0,2.25.07,3.79,0,3.2.06,7.61.06,12.5v.9l-.26-.21c4.56-1,8.66-1.87,11.62-2.48l3.51-.69A7,7,0,0,1,429.3,75.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.63,88a3.37,3.37,0,0,1,.14-.51c.09-.33.28-.8.45-1.42a37.66,37.66,0,0,0,1.22-5.34A36.08,36.08,0,0,0,440.8,48.13a38.21,38.21,0,0,0-4.33-3.36c-.53-.38-1-.62-1.25-.82a2.67,2.67,0,0,1-.43-.3,2.79,2.79,0,0,1,.47.23c.3.17.76.39,1.3.75A32.42,32.42,0,0,1,441,47.9a35.46,35.46,0,0,1,11.74,32.89,33,33,0,0,1-1.36,5.35c-.2.62-.41,1.08-.53,1.4A2.16,2.16,0,0,1,450.63,88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.6,72.68c-.07,0-.11-1.24-.36-3.22a37.77,37.77,0,0,0-5-14.66c-1-1.72-1.75-2.72-1.69-2.77a4.07,4.07,0,0,1,.58.66c.35.44.82,1.1,1.37,2a33.33,33.33,0,0,1,3.42,7.09,33,33,0,0,1,1.64,7.7c.09,1,.12,1.82.12,2.38A3.36,3.36,0,0,1,456.6,72.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.36,59.42a1.8,1.8,0,0,1-.21.48c-.15.31-.41.74-.68,1.33a39.27,39.27,0,0,0-2.05,5.08,36.63,36.63,0,0,0,10.05,38.06c.46.46.86.77,1.11,1a2.47,2.47,0,0,1,.37.37,2.22,2.22,0,0,1-.43-.3c-.27-.21-.68-.51-1.16-.94a32.38,32.38,0,0,1-3.86-3.94,35.44,35.44,0,0,1-6.37-34.34,33.55,33.55,0,0,1,2.19-5.06c.3-.58.58-1,.75-1.3A4.05,4.05,0,0,1,381.36,59.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,73.61c.07,0-.09,1.24-.15,3.24a38.45,38.45,0,0,0,.52,7.77,39.16,39.16,0,0,0,2.1,7.5c.73,1.86,1.3,3,1.23,3a3.28,3.28,0,0,1-.47-.74c-.27-.49-.64-1.22-1-2.14A33.16,33.16,0,0,1,373,84.7a33.79,33.79,0,0,1-.4-7.86c.07-1,.18-1.82.27-2.37A3.23,3.23,0,0,1,373,73.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.81,81.37c-1.18-.24-2.13-.45-2.13-.46s1,.18,2.14.42,2.12.44,2.12.45S441,81.61,439.81,81.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.81,81.37c0-.07.5,0,1.28.07l.64.09.17,0H442s-.22,0-.23.15a.23.23,0,0,0,.11.27s0,0,0,0l-.37-.07-1.66-.33-1.65-.35-.36-.08s-.11,0,0,0a.23.23,0,0,0,.19-.23c0-.11-.17-.24-.15-.21h.05l.17,0,.62.17c.76.21,1.22.37,1.21.44a3.16,3.16,0,0,1-1.29-.08l-.63-.11-.18,0h-.08s-.19-.1-.17-.22.08-.22.21-.22h.15l.38.06c.52.08,1.08.19,1.67.31s1.15.25,1.65.37l.37.09.14,0a.25.25,0,0,1,.12.29c0,.11-.24.18-.25.15h-.08l-.17,0L441,81.8C440.26,81.6,439.79,81.44,439.81,81.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.79,89.22c-1-.61-1.87-1.11-1.86-1.12s.85.47,1.88,1.08,1.87,1.11,1.86,1.12S437.82,89.83,436.79,89.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.79,89.22c0-.06.49.13,1.19.48l.57.3.15.07,0,0h0s-.22,0-.26.07a.22.22,0,0,0,0,.29s0,0-.05,0l-.32-.19-1.46-.84-1.45-.87-.32-.19s-.1,0,0,0a.23.23,0,0,0,.26-.15c.07-.1-.08-.28-.07-.24h0l0,0,.15.09.53.36c.65.45,1,.75,1,.81s-.49-.13-1.19-.49l-.57-.31-.16-.09,0,0,0,0s-.16-.16-.09-.26a.23.23,0,0,1,.27-.15l.14.06.34.18q.69.38,1.47.84c.52.3,1,.6,1.45.88l.32.21.11.08a.26.26,0,0,1,0,.31c-.05.1-.29.09-.29.06h0l-.05,0-.15-.09-.55-.35C437.14,89.59,436.75,89.28,436.79,89.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.37,95.66C430.6,94.74,430,94,430,94s.65.73,1.43,1.64,1.4,1.66,1.39,1.66S432.15,96.57,431.37,95.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.37,95.66c.06,0,.42.28,1,.84l.45.46.12.13,0,0h0s-.2-.1-.27,0a.22.22,0,0,0-.08.29s0,0,0,0l-.25-.29-1.1-1.27-1.09-1.29-.24-.29s-.08-.08,0,0a.23.23,0,0,0,.29-.06c.1-.07,0-.3,0-.26v0l0,0,.11.14.38.51c.47.63.74,1,.68,1.09s-.42-.28-1-.86l-.44-.47-.12-.14,0,0,0,0s-.09-.19,0-.28a.24.24,0,0,1,.31,0,.6.6,0,0,1,.11.1l.26.28c.36.38.73.81,1.12,1.27s.76.9,1.08,1.31l.24.3s0,0,.08.11,0,.29-.08.3-.3,0-.29,0l0,0,0,0-.11-.14-.41-.51C431.59,96.12,431.32,95.7,431.37,95.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.17,100c-.44-1.11-.79-2-.78-2s.38.89.82,2,.79,2,.78,2S424.61,101.11,424.17,100Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.17,100c.07,0,.31.4.65,1.11l.27.58.07.16,0,0h0s-.16-.17-.25-.11a.22.22,0,0,0-.17.25s0,0,0,0l-.15-.34c-.21-.52-.42-1-.63-1.57l-.61-1.57-.14-.35s0-.1,0,0a.23.23,0,0,0,.29,0c.12,0,.11-.28.1-.25V98l.06.16.2.61c.24.75.36,1.22.29,1.25s-.31-.4-.64-1.12c-.08-.2-.17-.39-.26-.59l-.07-.16V98s0-.22.09-.26.23,0,.3,0a.51.51,0,0,1,.07.14l.16.35c.21.47.43,1,.65,1.56s.43,1.09.6,1.58l.13.37s0,0,0,.13-.1.27-.16.26-.29-.11-.27-.13v0l0,0-.06-.17c-.07-.2-.14-.4-.22-.61A3.33,3.33,0,0,1,424.17,100Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,101.76c-.05-1.2-.09-2.17-.08-2.17s.07,1,.12,2.16.09,2.17.08,2.17S416,103,416,101.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,101.76c.07,0,.16.48.25,1.26l.07.64v.21h0s-.09-.21-.2-.18-.24.06-.24.17,0,0,0,0l0-.38c0-.56-.06-1.11-.09-1.68s0-1.13-.06-1.69V99.7s0-.1,0,0a.24.24,0,0,0,.27.14c.12,0,.19-.23.17-.2h0v.22c0,.21,0,.42,0,.64a3.26,3.26,0,0,1-.13,1.28,3.28,3.28,0,0,1-.24-1.27c0-.22,0-.43,0-.64v-.26s0-.22.17-.22.23,0,.27.15a.69.69,0,0,1,0,.15l0,.38c0,.52.08,1.09.1,1.69s.05,1.17.05,1.7v.38a.59.59,0,0,1,0,.14c0,.11-.19.22-.25.19s-.23-.2-.2-.21v-.26c0-.21,0-.42,0-.64A3.31,3.31,0,0,1,416,101.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.6,100.75c.33-1.15.61-2.08.62-2.08s-.25.94-.58,2.09-.62,2.08-.63,2.08S407.26,101.9,407.6,100.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.6,100.75c.07,0,0,.5-.18,1.27-.05.21-.09.42-.14.63l0,.17v.05s0-.23-.13-.24a.24.24,0,0,0-.28.09s0,0,0,0l.1-.36c.15-.54.3-1.07.46-1.62s.32-1.08.48-1.62l.11-.36s0-.1,0,0a.24.24,0,0,0,.2.22c.12,0,.26-.16.23-.14v0l-.06.17-.22.6c-.27.74-.46,1.19-.53,1.17s0-.51.18-1.28l.16-.62,0-.18,0,0v0s.11-.19.23-.15.21.09.21.22a.8.8,0,0,1,0,.15l-.09.38c-.12.5-.27,1.06-.44,1.63s-.34,1.13-.5,1.62l-.13.36a.45.45,0,0,1-.05.13.23.23,0,0,1-.29.1c-.11,0-.16-.25-.13-.26v-.07l.05-.18.21-.61C407.33,101.18,407.53,100.73,407.6,100.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,97.09c.69-1,1.26-1.77,1.27-1.76s-.54.81-1.24,1.79-1.26,1.76-1.27,1.76S399.33,98.07,400,97.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,97.09c.06,0-.17.48-.58,1.15-.12.18-.23.36-.34.54l-.09.15,0,0v0s.06-.23,0-.27a.23.23,0,0,0-.3,0s0,0,0,0l.22-.31,1-1.39c.34-.46.66-.91,1-1.37l.22-.3s.05-.09,0,0a.23.23,0,0,0,.13.27c.1.07.29-.06.25-.05h0l0,0-.11.13-.4.5c-.5.61-.83,1-.89.93s.17-.48.59-1.14c.12-.19.23-.37.35-.54l.1-.15,0,0,0,0s.17-.14.27-.07a.24.24,0,0,1,.12.29c-.06.12-.05.08-.07.13l-.21.33c-.28.43-.61.9-1,1.39s-.69,1-1,1.37l-.24.3-.09.11a.24.24,0,0,1-.31,0c-.1-.05-.07-.29,0-.29l0,0,0,0,.1-.15.4-.51C399.63,97.41,400,97.05,400,97.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.05,91.17l1.77-1.26s-.77.59-1.74,1.29-1.77,1.26-1.78,1.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.05,91.17c0,.06-.31.39-.92.89l-.5.41-.13.11,0,0v0s.12-.2,0-.28a.23.23,0,0,0-.28-.1l0,0,.3-.22,1.36-1,1.38-1,.31-.21s.08-.07,0,0a.24.24,0,0,0,0,.3c.07.11.3,0,.26,0h0l0,0-.15.09-.54.35c-.66.41-1.1.65-1.14.59s.31-.4.93-.89l.51-.4.14-.11,0,0h0s.2-.08.27,0,.11.21,0,.3l-.11.11-.3.24c-.42.32-.87.66-1.36,1s-1,.68-1.39,1l-.32.21-.12.07c-.1.06-.29,0-.29-.1s0-.3.05-.28l0,0,0,0,.15-.11.53-.35C393.58,91.34,394,91.11,394.05,91.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.32,83.63c1.15-.35,2.08-.62,2.08-.61s-.92.3-2.07.65-2.08.62-2.08.61S389.17,84,390.32,83.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.32,83.63c0,.07-.43.27-1.16.55l-.6.22-.17.06,0,0h0s.18-.14.13-.25-.12-.21-.23-.18,0,0,.05,0l.35-.12,1.62-.5,1.61-.48.36-.1s.1,0,0,0a.23.23,0,0,0-.07.29c0,.12.27.14.24.12h-.06l-.17,0-.62.15c-.77.18-1.25.26-1.27.19s.42-.27,1.16-.54c.21-.07.41-.15.62-.21l.17-.06h.07s.22,0,.26.11a.24.24,0,0,1-.08.3l-.14.06-.36.13c-.49.17-1,.34-1.61.52s-1.13.33-1.63.46l-.37.1-.14,0c-.11,0-.26-.13-.24-.19s.13-.28.14-.25h0l.05,0,.17-.05.63-.16C389.81,83.64,390.3,83.56,390.32,83.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.24,75.29c1.2,0,2.17.09,2.17.1s-1,0-2.17-.06l-2.17-.1S388,75.24,389.24,75.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.24,75.29a3.27,3.27,0,0,1-1.28.14h-.87s.22-.07.2-.18a.22.22,0,0,0-.15-.26s0,0,.05,0h.37l1.69,0,1.69.07.37,0s.11,0,0,0a.23.23,0,0,0-.15.26c0,.12.21.21.18.18h-.23l-.64-.07a3.38,3.38,0,0,1-1.26-.23,3.18,3.18,0,0,1,1.28-.13h.91s.21.07.2.19a.24.24,0,0,1-.17.26.43.43,0,0,1-.15,0h-.39l-1.69,0c-.6,0-1.17,0-1.69-.09l-.38,0-.14,0c-.11,0-.21-.2-.17-.26s.21-.22.22-.19h.26l.64,0A3.18,3.18,0,0,1,389.24,75.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.93,67c1.12.43,2,.79,2,.8s-.92-.33-2-.76-2-.78-2-.79S389.81,66.62,390.93,67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.93,67c0,.07-.5,0-1.25-.27l-.62-.2-.16,0h0s.23,0,.24-.12a.21.21,0,0,0-.06-.28s0,0,.05,0l.35.13,1.58.59,1.57.62.35.13s.1,0,0,0a.23.23,0,0,0-.22.19c-.05.12.13.27.11.23h0l0,0-.16-.07-.58-.27c-.71-.33-1.15-.56-1.12-.63a3.42,3.42,0,0,1,1.25.29l.62.21.16.06.05,0h0s.18.13.13.25a.23.23,0,0,1-.24.18l-.15,0-.37-.12-1.59-.58-1.57-.63-.35-.16-.12-.06a.24.24,0,0,1-.08-.3c0-.11.26-.14.27-.11h0l0,0,.17.07.59.25C390.53,66.74,391,67,390.93,67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.2,59.8c.92.77,1.66,1.4,1.65,1.41s-.76-.61-1.67-1.38-1.66-1.4-1.65-1.41S394.28,59,395.2,59.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.2,59.8c0,.05-.46-.21-1.09-.68-.18-.12-.35-.25-.52-.38l-.14-.1,0,0h0s.22.07.27,0a.22.22,0,0,0,0-.29s0,0,0,0l.29.24,1.3,1.07,1.29,1.1.28.24s.09.06,0,0a.23.23,0,0,0-.28.1c-.08.09,0,.3,0,.26h0l0,0-.12-.12-.47-.44c-.56-.55-.89-.91-.85-1s.46.2,1.09.68l.51.39.14.12,0,0,0,0s.13.18.05.28a.24.24,0,0,1-.29.09.4.4,0,0,1-.13-.08l-.31-.23c-.41-.32-.85-.68-1.31-1.07s-.89-.76-1.28-1.11l-.28-.26-.1-.1a.25.25,0,0,1,0-.31c.06-.09.3,0,.29,0l0,0,0,0,.13.12.48.43C394.92,59.38,395.25,59.74,395.2,59.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.6,54.34c.62,1,1.11,1.86,1.1,1.87s-.52-.82-1.14-1.85-1.11-1.86-1.1-1.87S401,53.31,401.6,54.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.6,54.34c-.07,0-.37-.35-.82-1l-.37-.53-.1-.14,0,0h0s.18.14.27.07.18-.18.12-.27,0,0,0,0l.2.32.88,1.43c.3.5.58,1,.86,1.46l.2.32s.06.09,0,0a.22.22,0,0,0-.29,0c-.11.06-.06.29-.06.25h0l0,0-.08-.15-.3-.57c-.36-.7-.56-1.15-.49-1.18s.36.34.81,1l.35.54.1.16,0,0,0,0s.06.21,0,.27a.24.24,0,0,1-.31,0,.52.52,0,0,1-.09-.12l-.21-.32q-.44-.66-.9-1.44c-.31-.51-.6-1-.85-1.46l-.19-.34a1.22,1.22,0,0,1-.06-.12.26.26,0,0,1,.12-.29c.09-.06.3.06.28.09l0,0,0,0,.09.16.31.56C401.46,53.85,401.66,54.3,401.6,54.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.41,51.24c.25,1.17.45,2.12.44,2.13s-.23-.95-.48-2.12-.45-2.13-.44-2.13S409.16,50.07,409.41,51.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.41,51.24c-.07,0-.24-.45-.45-1.2l-.18-.62,0-.17v0h0s.13.19.23.15.22-.11.21-.22,0,0,0,0l.08.36c.13.55.25,1.09.37,1.65s.23,1.11.35,1.65l.07.37s0,.1,0,0a.22.22,0,0,0-.28-.09c-.13,0-.15.25-.14.22v-.06l0-.17-.1-.63a3.34,3.34,0,0,1-.08-1.28c.07,0,.24.44.44,1.2.06.22.11.42.17.63l0,.18v.07s0,.22-.13.25-.24,0-.29-.1,0-.1,0-.15l-.1-.37c-.13-.5-.26-1.06-.39-1.65s-.23-1.15-.33-1.66l-.06-.38s0,0,0-.13.15-.25.21-.23.26.15.24.16v.08l0,.18.12.63A3.3,3.3,0,0,1,409.41,51.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.81,50.85c-.14,1.19-.27,2.16-.28,2.16s.1-1,.24-2.16.27-2.16.28-2.16S418,49.66,417.81,50.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.81,50.85a3.44,3.44,0,0,1,0-1.28l0-.64V48.7s.05.22.17.21a.22.22,0,0,0,.26-.13s0,0,0,0l0,.37c-.06.56-.13,1.11-.19,1.68s-.14,1.12-.21,1.67l-.05.38s0,.1,0,0a.22.22,0,0,0-.23-.18c-.13,0-.23.19-.2.17v-.06l0-.17c0-.2.08-.41.11-.63.15-.77.27-1.25.34-1.24a3.24,3.24,0,0,1,0,1.29c0,.22,0,.43,0,.64l0,.18V53s-.08.2-.21.19-.22-.06-.24-.19a.6.6,0,0,1,0-.15l0-.39c0-.52.1-1.09.17-1.68s.15-1.17.23-1.68l.07-.38s0,0,0-.13.22-.19.27-.15.2.22.18.23v.08l0,.18c0,.21-.06.42-.1.64C418,50.39,417.88,50.86,417.81,50.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.89,53.21c-.52,1.08-.95,1.95-1,1.95s.4-.89.92-2,.95-1.95,1-1.95S426.41,52.13,425.89,53.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.89,53.21a3.48,3.48,0,0,1,.38-1.23c.08-.2.17-.4.24-.59l.07-.16v0h0s0,.22.09.25a.21.21,0,0,0,.29,0s0,0,0,0l-.16.34c-.24.5-.48,1-.72,1.52l-.75,1.52-.16.34s0,.1,0,0a.24.24,0,0,0-.17-.24c-.11-.06-.28.11-.24.09h0l0,0,.09-.15.31-.56c.39-.68.66-1.09.72-1.06s-.09.5-.39,1.23l-.26.59-.07.16,0,.05,0,0s-.14.17-.25.11-.2-.13-.17-.25l.05-.15.15-.35c.21-.48.45-1,.71-1.54s.51-1,.76-1.52l.18-.33a.61.61,0,0,1,.07-.12c.06-.1.27-.11.31,0s.11.27.08.27v0l0,0-.08.16-.3.57C426.23,52.83,426,53.24,425.89,53.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.76,58.07c-.85.85-1.54,1.53-1.55,1.52s.67-.7,1.52-1.55,1.53-1.54,1.54-1.53S433.6,57.21,432.76,58.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.76,58.07c-.05-.06.24-.45.76-1l.42-.48.12-.13,0,0h0s-.09.2,0,.27a.22.22,0,0,0,.29.05s0,0,0,0l-.26.27c-.39.4-.77.8-1.18,1.21l-1.19,1.19-.27.26s-.07.08,0,0a.24.24,0,0,0-.08-.29c-.08-.09-.3,0-.26,0h0l0,0,.13-.12.48-.42c.59-.52,1-.83,1-.77s-.25.44-.77,1c-.15.16-.29.32-.44.47l-.12.13,0,0,0,0s-.19.11-.28,0a.24.24,0,0,1-.07-.3l.09-.12.26-.28c.35-.39.75-.8,1.17-1.23s.83-.82,1.22-1.18l.28-.26a.49.49,0,0,1,.1-.09.26.26,0,0,1,.31,0c.09.07,0,.3,0,.29l0,0,0,0-.13.13-.47.44C433.2,57.82,432.81,58.12,432.76,58.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.68,64.88c-1.08.54-1.95,1-2,1s.86-.45,1.94-1,1.95-1,1.95-.95S438.75,64.35,437.68,64.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.68,64.88c0-.06.37-.33,1.05-.73l.56-.32.15-.09,0,0h0s-.15.17-.08.26a.23.23,0,0,0,.26.15s0,0-.05,0l-.33.17-1.51.76-1.51.74-.34.16s-.09.06,0,0a.24.24,0,0,0,0-.3c0-.11-.28-.08-.25-.07h.06l.15-.07.6-.25a3.43,3.43,0,0,1,1.22-.4c0,.07-.38.34-1.06.73l-.57.31-.16.08-.05,0h0s-.22,0-.27-.07a.23.23,0,0,1,0-.31,1.08,1.08,0,0,1,.13-.08l.34-.19q.69-.37,1.5-.78c.54-.26,1.06-.51,1.53-.72l.35-.16.13,0c.11,0,.28.08.27.14s-.08.3-.1.28h0l0,0-.16.08-.59.27C438.17,64.79,437.71,65,437.68,64.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.12,72.93c-1.19.15-2.15.27-2.15.26s1-.15,2.15-.3,2.15-.28,2.15-.27S441.31,72.77,440.12,72.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.12,72.93c0-.08.47-.2,1.24-.36l.63-.12.17,0h0s-.2.11-.16.22.08.23.19.22h0l-.38,0-1.67.23-1.67.21-.38,0s-.1,0,0,0a.22.22,0,0,0,.11-.28c0-.12-.24-.17-.21-.15h.23l.64,0c.78-.05,1.27-.05,1.28,0s-.46.2-1.24.34l-.63.11-.18,0H438s-.22,0-.23-.15,0-.23.12-.28l.15,0,.38-.06c.51-.09,1.08-.17,1.67-.25s1.17-.15,1.69-.19l.38,0h.14c.11,0,.23.16.21.22s-.17.25-.19.23h-.08l-.18,0-.64.06A3.28,3.28,0,0,1,440.12,72.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.8,69A22.72,22.72,0,0,1,457,73.06l0,.1-.17.33-.2-.31a22.3,22.3,0,0,1-2.2-3.73A21.56,21.56,0,0,1,457,72.94l-.38,0,.05-.09A23,23,0,0,1,458.8,69Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 168.98,
    cy: 165.62,
    r: 28.69,
    transform: "translate(-52.47 82.28) rotate(-23.8)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.71,188.63s-.32,0-.84.19a3.79,3.79,0,0,0-1.84,1.36,3.59,3.59,0,0,0-.65,1.44,3.16,3.16,0,0,0,.18,1.78,3.44,3.44,0,0,0,6.45.1,3.16,3.16,0,0,0,.24-1.77,3.63,3.63,0,0,0-.6-1.46,3.81,3.81,0,0,0-1.8-1.41c-.52-.19-.84-.2-.83-.23h.22a1.7,1.7,0,0,1,.28,0,2.1,2.1,0,0,1,.36.09,3.88,3.88,0,0,1,2.59,2.93,3.46,3.46,0,0,1-.23,1.91,4,4,0,0,1-1.33,1.64,3.46,3.46,0,0,1-4.3-.06,4,4,0,0,1-1.28-1.69,3.37,3.37,0,0,1-.17-1.92,3.9,3.9,0,0,1,2.68-2.84,1.37,1.37,0,0,1,.37-.08l.27,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.59,170s0-.16,0-.47.07-.77.12-1.37c0-.3.06-.63.1-1s0-.78,0-1.23v-1.42a5.29,5.29,0,0,0,0-.79c0-.27-.06-.54-.09-.83a27.61,27.61,0,0,0-2-8.07,28.61,28.61,0,0,0-6-9.2l-1.09-1.11c-.39-.35-.8-.68-1.21-1l-.62-.52a5.34,5.34,0,0,0-.65-.5l-1.36-.94c-.24-.15-.46-.32-.7-.47l-.75-.41-1.51-.83c-.51-.26-1.06-.47-1.6-.71l-.82-.35-.42-.17-.43-.13a27,27,0,0,0-3.53-1c-.61-.11-1.22-.27-1.84-.35l-1.9-.2c-.32,0-.64-.07-1-.08h-1c-.65,0-1.31,0-2,0a32,32,0,0,0-4,.53l-1,.2-.5.11-.49.15-2,.6c-.65.23-1.28.52-1.93.78-.32.15-.66.26-1,.42l-.93.5a32.3,32.3,0,0,0-3.65,2.25l-1.69,1.36-.43.35-.39.38-.78.77-.79.78-.72.84-.72.86-.36.42-.32.46-1.27,1.86-1.1,2a28.42,28.42,0,0,0-2.76,17.94c.15.75.29,1.49.44,2.23l.66,2.15.17.54.21.51.43,1,.42,1,.52,1,.52,1,.26.48.3.46c.4.6.81,1.21,1.2,1.81a31.24,31.24,0,0,0,2.81,3.24l.74.76c.24.25.53.46.79.69.54.44,1.06.91,1.61,1.33l1.7,1.17.42.29.45.25.89.49a31.23,31.23,0,0,0,3.62,1.7c.62.23,1.25.4,1.87.6l.92.29c.31.09.63.14,1,.21l1.86.39c.62.1,1.25.14,1.87.21a25.05,25.05,0,0,0,3.66.14h.45l.45,0,.88-.09c.59-.06,1.18-.09,1.75-.19l1.69-.33.83-.17.81-.24,1.59-.48a6.92,6.92,0,0,0,.76-.28l.75-.31c.49-.21,1-.4,1.46-.62l1.38-.73a28.76,28.76,0,0,0,8.48-7L192,183l.65-.95.64-.92c.1-.15.21-.29.3-.45l.25-.46c.34-.61.67-1.19,1-1.75s.51-1.13.74-1.65l.34-.77a5.58,5.58,0,0,0,.28-.74c.15-.48.29-.93.43-1.35s.27-.81.36-1.17.15-.69.21-1c.13-.59.23-1,.29-1.34s.11-.46.11-.46,0,.16-.08.46-.15.76-.27,1.35c-.05.3-.12.63-.19,1s-.23.75-.35,1.17-.28.88-.43,1.37a4.31,4.31,0,0,1-.27.73l-.33.78c-.23.52-.44,1.1-.73,1.66l-1,1.77-.25.46c-.09.16-.2.3-.3.45l-.63.92c-.22.32-.43.64-.66,1s-.51.62-.77.93a28.64,28.64,0,0,1-8.5,7l-1.38.74c-.48.22-1,.41-1.48.62l-.75.31a5.08,5.08,0,0,1-.77.29l-1.59.49-.81.24-.84.17-1.71.34c-.57.1-1.16.13-1.76.2l-.89.09c-.15,0-.3,0-.45,0H170a27,27,0,0,1-3.69-.13c-.62-.07-1.26-.11-1.88-.21l-1.89-.39c-.31-.07-.63-.12-1-.21l-.93-.29c-.62-.2-1.26-.38-1.88-.61a29.49,29.49,0,0,1-3.66-1.7l-.9-.5-.45-.25-.42-.29-1.72-1.18c-.56-.42-1.08-.89-1.62-1.34a10.69,10.69,0,0,1-.81-.7l-.74-.76a31.86,31.86,0,0,1-2.84-3.27L144.39,181l-.3-.46-.27-.48-.52-1-.52-1-.44-1-.43-1-.21-.52-.17-.54c-.22-.72-.44-1.45-.67-2.18l-.45-2.24a31.08,31.08,0,0,1-.08-9.29,30.64,30.64,0,0,1,2.88-8.82l1.1-2,1.29-1.87.32-.47.37-.43.72-.86.72-.85.8-.78.79-.78.4-.39.43-.34q.85-.71,1.71-1.38a32,32,0,0,1,3.68-2.27l.94-.5c.32-.17.65-.28,1-.42.65-.26,1.29-.55,1.95-.79l2-.6.49-.16.51-.1,1-.2a30.67,30.67,0,0,1,4-.53c.67,0,1.33,0,2,0h1c.33,0,.65.06,1,.09l1.91.2c.63.09,1.24.24,1.86.36a26,26,0,0,1,3.56,1l.43.13.42.18.82.35c.54.24,1.1.45,1.62.72l1.52.84.75.41.7.48,1.37,1a4,4,0,0,1,.65.5l.63.52c.4.36.82.69,1.21,1l1.1,1.12a28.8,28.8,0,0,1,6,9.27,27.43,27.43,0,0,1,1.95,8.12c0,.29.06.57.08.84a4.23,4.23,0,0,1,0,.79c0,.51,0,1,0,1.42s0,.86,0,1.23-.08.71-.11,1c-.07.59-.12,1.05-.16,1.37S197.59,170,197.59,170Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.42,159.28h4.05a3.44,3.44,0,0,1,3.53-3.46,3.28,3.28,0,0,1,3.17,2.09,3.63,3.63,0,0,1-.29,3.28c-.69,1.13-2.19,2.16-4.92,1.68V172h4v-5.34a7.82,7.82,0,0,0,5.62-7.64c0-5.92-5.31-7.29-7.58-7.29C167.26,151.72,161.34,152.14,161.42,159.28Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.95,
    y: 173.87,
    width: 4.06,
    height: 3.79,
    style: {
      fill: "#0D6EFD"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.67,426.48c-.09.12-14-10.21-31-23.06S219.9,380.06,220,380s14,10.2,31,23.06S281.75,426.37,281.67,426.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.67,427.68c-.09-.11,13.78-10.89,31-24.07s31.19-23.78,31.28-23.66S262.14,390.84,245,404,213.76,427.79,213.67,427.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.9 368.12 221.44 381.41 225.09 381.41 228.85 368.12 223.9 368.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.57,377.52c-3.22,16.19-15.73,76.63-18.88,91.89a2.88,2.88,0,0,0,2.75,3.51h0a2.81,2.81,0,0,0,2.71-2.13l24.39-90.91a5,5,0,0,0-4.67-6.35h-1.54A4.89,4.89,0,0,0,217.57,377.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.26 368.12 274.72 381.41 271.07 381.41 267.31 368.12 272.26 368.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,351c-7.09-13.17-15.54-53.38-19.26-66.21-.1-.36-.21-.71-.32-1.05a20.71,20.71,0,0,0-19.75-14H237.24a20.73,20.73,0,0,0-19.76,14c-.11.34-.22.69-.32,1.05-3.72,12.83-12.16,53-19.26,66.21,0,0-9.46,5.57-6.75,10.9,2.6,5.13,26.89,8.77,56.8,7.81,29.9,1,54.19-2.68,56.8-7.81C307.45,356.57,298,351,298,351Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,351a17.73,17.73,0,0,1,2.35,1.59,18.58,18.58,0,0,1,2.55,2.32,9.05,9.05,0,0,1,2.34,4.08,4.77,4.77,0,0,1-.34,2.81,5.2,5.2,0,0,1-2.26,2.16,17.76,17.76,0,0,1-3.12,1.39,36.61,36.61,0,0,1-3.53,1.08,112.21,112.21,0,0,1-17.15,2.7c-6.44.6-13.55.91-21.22.92-1.91,0-3.87,0-5.85,0s-4-.14-6,0c-4.1.11-8.34.13-12.69,0a187.76,187.76,0,0,1-27.39-2.28,69.13,69.13,0,0,1-7.11-1.58A30.34,30.34,0,0,1,195,365a11.87,11.87,0,0,1-3.27-1.91,3.72,3.72,0,0,1-1.05-1.67c-.05-.15-.12-.31-.16-.47l-.06-.49-.06-.49c0-.17,0-.33.05-.5a7.44,7.44,0,0,1,1.5-3.56,21.64,21.64,0,0,1,5.81-5.09l-.09.1a103.13,103.13,0,0,0,6-15.8c1.69-5.49,3.24-11.11,4.73-16.82,1.56-6,3-11.9,4.47-17.74q1.08-4.38,2.16-8.7c.74-2.87,1.42-5.72,2.35-8.52A20.66,20.66,0,0,1,229,271.12a22,22,0,0,1,8.2-1.63h19.94a33,33,0,0,1,3.85.15,21.46,21.46,0,0,1,7.23,2.13,21.14,21.14,0,0,1,5.85,4.36A20.2,20.2,0,0,1,278,282l.62,1.62c.17.55.34,1.09.49,1.64.29,1.09.6,2.16.87,3.23,1.11,4.28,2.11,8.41,3.08,12.34,3.82,15.74,7.13,28.42,9.91,37,1.35,4.32,2.63,7.59,3.53,9.8.45,1.1.88,1.89,1.13,2.45s.38.85.38.85-.6-1.09-1.6-3.26-2.25-5.47-3.64-9.78c-2.83-8.61-6.21-21.29-10.07-37-1-3.93-2-8.05-3.11-12.32-.27-1.07-.58-2.14-.88-3.23-.14-.55-.32-1.08-.48-1.62s-.41-1-.61-1.58a19.77,19.77,0,0,0-3.81-5.76A20.62,20.62,0,0,0,261,270.11a29.83,29.83,0,0,0-3.8-.14H245.35c-5.31.17-11-.67-16.13,1.61a20.2,20.2,0,0,0-11.36,11.89c-.91,2.74-1.59,5.62-2.33,8.48s-1.44,5.77-2.16,8.69c-1.44,5.85-2.91,11.77-4.47,17.76-1.49,5.71-3,11.34-4.74,16.84a102.43,102.43,0,0,1-6,15.88l0,.06-.07,0a21.21,21.21,0,0,0-5.66,4.95,6.91,6.91,0,0,0-1.41,3.31c0,.15,0,.3,0,.44l.05.44.05.44c0,.14.1.28.14.42a3.25,3.25,0,0,0,.92,1.46,11.3,11.3,0,0,0,3.12,1.82,28.7,28.7,0,0,0,3.45,1.19,68.22,68.22,0,0,0,7.06,1.58A188.17,188.17,0,0,0,233,369.58q6.53.14,12.68,0c2-.11,4.07,0,6.06,0s3.93.06,5.84.06c7.66,0,14.76-.29,21.19-.86a112.33,112.33,0,0,0,17.12-2.63c1.23-.31,2.41-.65,3.51-1a18.16,18.16,0,0,0,3.09-1.37,5.06,5.06,0,0,0,2.19-2,4.62,4.62,0,0,0,.34-2.69,9,9,0,0,0-2.26-4,19.58,19.58,0,0,0-2.51-2.34c-.72-.58-1.3-1-1.7-1.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.32,377.52c3.23,16.19,15.73,76.63,18.89,91.89a2.88,2.88,0,0,1-2.76,3.51h0a2.83,2.83,0,0,1-2.71-2.13l-24.39-90.91a5,5,0,0,1,4.68-6.35h1.54A4.88,4.88,0,0,1,278.32,377.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.6,358.27l-.23.06-.67.12-2.59.4c-2.25.34-5.52.77-9.56,1.23-8.09.92-19.31,1.81-31.74,2s-23.68-.33-31.79-1c-4.06-.32-7.34-.64-9.6-.91l-2.6-.31-.67-.1a.65.65,0,0,1-.23-.05h.23l.68,0,2.61.22c2.27.21,5.55.47,9.61.75,8.11.55,19.34,1,31.75.82s23.62-1,31.71-1.88c4-.41,7.32-.78,9.57-1.06l2.61-.31.67-.06A.62.62,0,0,1,293.6,358.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M287.26,353.65c-.78-1.92-3.89-2.4-6.44-2.52a412.47,412.47,0,0,0-71.6,2.76,4.51,4.51,0,0,0-1.94.54c-.53.35-.76,1-.3,1.45l-.11,1.19c23.6,5.19,48.67,4.11,73,1.55a15.22,15.22,0,0,0,5.32-1.21C286.71,356.61,287.82,355.06,287.26,353.65Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M216.52,301.18s-12.93,11.61-15.62,24.68c-4,19.22,6.35,34.22,6.35,34.22,19.92,1.06,37.54,2.17,71.54,0l.58-49.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.35,275.45c-.16-.55-4.76-16.67-4.76-16.67l19-10.6L268,269.32Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.39,236.15c-1.94-4.35-5.11-7.1-10.1-8.84L273.14,223H237.88s-16.24.61-22.07,8.89L219,280.26s.88,8.53-8.36,27.19c0,0,7,9,18.33,9s50-4.91,50-4.91l3.86-21.16,11.47-25.53a80.4,80.4,0,0,0,5.36-17A20.29,20.29,0,0,0,298.39,236.15Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.32,289.38a4.32,4.32,0,0,1-.2-.56c-.13-.41-.29-1-.51-1.66-.44-1.48-1.07-3.6-1.85-6.25-1.57-5.42-3.78-13.05-6.4-22.07l-.05-.18.16-.09,19-10.62.3-.16.08.32c.15.58.31,1.2.46,1.82,1.73,6.84,3.38,13.37,4.88,19.33l-.45,0c4.34-9.43,8-17.5,10.69-23.24l3.1-6.65.85-1.76a4.06,4.06,0,0,1,.31-.6,4.48,4.48,0,0,1-.24.63l-.77,1.79-3,6.71-10.52,23.32-.29.64-.17-.68c-1.51-5.95-3.17-12.49-4.91-19.32-.16-.62-.32-1.24-.46-1.82l.38.17L243.7,259l.12-.27c2.54,9,4.68,16.69,6.21,22.12.73,2.67,1.31,4.8,1.73,6.29.18.71.33,1.26.43,1.68A3.41,3.41,0,0,1,252.32,289.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.65,229.79a19.86,19.86,0,0,0-7,15.35c.23,9.8,11.13,59.81,18.63,64,7.85,4.41,11.68,3.24,16.15,3.24s37.38-2.84,37.38-2.84l-.12-21.16-36.45,1.17-12.9-46.14Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.27,262s.06.18.15.52.23.88.4,1.53c.34,1.37.84,3.36,1.48,5.9,1.31,5.11,3.17,12.53,5.77,21.61.66,2.27,1.38,4.63,2.21,7.07a26.66,26.66,0,0,0,3.5,7.13,14.86,14.86,0,0,0,6.59,5.16,21.32,21.32,0,0,0,8.88,1.24c6.23-.24,12.78-.72,19.56-1.21l21-1.61-.24.26V309c0-7.07-.08-14-.11-20.62l.26.26-36.46,1.13h-.17l0-.17c-3.85-13.9-7-25.44-9.28-33.53-1.1-4-2-7.18-2.55-9.36q-.43-1.59-.66-2.46c-.14-.56-.2-.85-.2-.85s.1.28.27.83.4,1.39.71,2.45c.63,2.17,1.53,5.32,2.67,9.33,2.28,8.07,5.54,19.59,9.46,33.47l-.22-.16,36.46-1.2H283v.26c0,6.65.08,13.55.12,20.61v.79l-.24,0-21,1.6c-6.79.48-13.33.95-19.59,1.18a21.65,21.65,0,0,1-9.06-1.29,15.32,15.32,0,0,1-6.77-5.34,26.69,26.69,0,0,1-3.53-7.25c-.82-2.45-1.54-4.83-2.18-7.1-2.56-9.1-4.36-16.53-5.61-21.66-.6-2.56-1.07-4.55-1.4-5.92-.14-.66-.26-1.18-.34-1.55S213.27,262,213.27,262Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M232.21,310.86a11.89,11.89,0,0,1-5.27-4.61c-4.06-6-6.3-14.81-7.71-21.11l-.5-.65a80.19,80.19,0,0,0,3.61,18.21c1.09,3.09,2.47,6.25,5,8.31a13.47,13.47,0,0,0,8.38,2.66,40.32,40.32,0,0,0,8.85-1.23C242.08,312.4,236.1,312.59,232.21,310.86Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "235.33 250.47 248.71 286.88 280.24 288.48 246.26 289.57 235.33 250.47"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M313.17,399.9l3.35,24.32s25.84,4.76,26.9,9.2l-46.92,8.19-6.77-37.68Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.66,424.72a2,2,0,0,0-1,2.42,1.86,1.86,0,0,0,2.39.95,2,2,0,0,0,1-2.56,1.94,1.94,0,0,0-2.6-.72",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.64,442.6,296,439l45.17-7.59s2.25.55,2.27,2.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.24,423.85c0,.23-1.1.53-2.09,1.47s-1.44,2-1.66,1.94-.12-1.43,1.11-2.54S317.25,423.63,317.24,423.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.52,425c.09.21-.84.77-1.45,1.88s-.65,2.17-.88,2.2-.6-1.25.18-2.6S322.47,424.81,322.52,425Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.34,430.43c-.2.08-.72-1-.35-2.36s1.35-2.05,1.48-1.87-.41,1-.7,2.08S326.56,430.37,326.34,430.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.86,418.39c-.06.23-1.17.1-2.44.41s-2.22.9-2.38.72.68-1.16,2.19-1.51S315.94,418.19,315.86,418.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.42,424l3.5,25.41L306.55,471a3.34,3.34,0,0,1-.34,4.87h0a3.3,3.3,0,0,1-3,.62c-6.64-1.86-37.29-13.19-37.29-13.19-1.19-5.15-5.38-29.24-5.38-29.24Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.17,460.18l41,15.72c-.85.72-2,1.55-3.07,1.25L266.61,464a1.07,1.07,0,0,1-.69-.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.33,454.37a2,2,0,0,1,1.73,2.07,1.93,1.93,0,0,1-2,1.73A2.13,2.13,0,0,1,270.2,456a2,2,0,0,1,2.32-1.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.65,462.58c.2,0,.47-1.8,2.1-3.18s3.45-1.46,3.44-1.67-.46-.22-1.22-.13a5.35,5.35,0,0,0-4.29,3.75C288.49,462.1,288.56,462.58,288.65,462.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.92,466.75c.2.06.62-1.37,1.88-2.59s2.66-1.66,2.61-1.86-1.7-.07-3.11,1.35S293.72,466.76,293.92,466.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.44,458.62c.18.11,1.38-1.84,3.65-3.37s4.5-2,4.46-2.17-2.45-.08-4.87,1.58S282.26,458.56,282.44,458.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.54,211.49c-.59-2.84,0-5.78.5-8.64s.75-5.93-.46-8.57c-1.52-3.32-5-5.24-7.22-8.16s-2.92-6.68-3.79-10.24-2.1-7.29-4.93-9.63c-3.57-3-11.6-2.31-14.92.94,2.71,20.62,1.17,42.18,8.76,61.53a55.26,55.26,0,0,0,27.77-11.5C283.35,217.09,281.13,214.33,280.54,211.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.33,230.2l-13.28-48.12a4.44,4.44,0,0,1,3.07-5.17l22.09-10.25c7.28-2.19,14,6,15.83,13.39,2.09,8.18,4.31,18.26,4.5,24.62.38,12.8-8.85,16.19-8.85,16.19l1.78,13.52-3.87,13.54-11.85,6.5Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.94,190.06a1.62,1.62,0,0,1-1.23,1.9,1.55,1.55,0,0,1-1.91-1.12,1.62,1.62,0,0,1,1.23-1.9A1.54,1.54,0,0,1,265.94,190.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.52,185.14c-.16.25-1.53-.42-3.25-.09s-2.81,1.42-3,1.25,0-.49.49-1a4.48,4.48,0,0,1,2.38-1.26,4.3,4.3,0,0,1,2.64.33C267.35,184.69,267.6,185,267.52,185.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3,193.19a1.63,1.63,0,0,1-1.23,1.9,1.55,1.55,0,0,1-1.91-1.13,1.62,1.62,0,0,1,1.23-1.9A1.55,1.55,0,0,1,250.3,193.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.88,189.27c-.16.25-1.53-.42-3.25-.09s-2.81,1.43-3,1.25,0-.49.49-1a4.48,4.48,0,0,1,2.38-1.26,4.37,4.37,0,0,1,2.64.33C251.71,188.82,252,189.16,251.88,189.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.7,200.81a11.55,11.55,0,0,1,2.69-1c.43-.13.83-.3.84-.61a2.25,2.25,0,0,0-.53-1.24l-1.93-3.09c-2.7-4.41-4.74-8.07-4.56-8.18s2.51,3.38,5.21,7.79l1.87,3.12a2.59,2.59,0,0,1,.55,1.68,1.1,1.1,0,0,1-.59.77,3.52,3.52,0,0,1-.73.25A11,11,0,0,1,259.7,200.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.72,220.89a32.13,32.13,0,0,1-17.48-1.3s5.85,8.07,18.07,4.56Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.49,182.07c-.08.5-1.83.6-3.8,1.22s-3.49,1.48-3.84,1.11c-.15-.17.05-.67.62-1.24a6.5,6.5,0,0,1,2.7-1.56,6.66,6.66,0,0,1,3.12-.22C250.08,181.54,250.52,181.83,250.49,182.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.15,180c-.23.44-1.49.26-2.91.51s-2.58.76-2.93.4c-.16-.17,0-.6.41-1.07a4.17,4.17,0,0,1,2.24-1.08,4.1,4.1,0,0,1,2.47.35C266,179.39,266.24,179.76,266.15,180Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,165.92c-3-5.11-7.73-4.84-12.79-4.61s-12.1,3.59-15.75,7.1c-2.85,2.74-6,6.14-7.8,9.66s-2.16,7-3,10.69c-1.26,5.77-.17,11.75.46,17.62a112,112,0,0,1,.17,22.2c-.24,2.65-.42,5.8,3.2,6.72a7.5,7.5,0,0,0,2.06.19c5.37-.16,10.74.84,16.65.3l3.61-.59c4.58-.73,6.41-4.23,5.62-8.17-2.38-11.91-11-30.71-12.24-34.39C236.18,192.64,230.05,166.42,256,165.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.31,166.31a7.41,7.41,0,0,0-1.8,5.57c0,2,.48,4,.42,6A12.57,12.57,0,0,1,247.22,188c-1.08.69-2.65,1.15-3.53.22a7,7,0,0,1-3.13,7.2c-1.73,1-3.82,1.25-5.7,2s-3.7,2.41-3.49,4.42l-3-13.73,1.94-12.88,10.84-9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.73,192.55a8.14,8.14,0,0,0,1-1.11,8.5,8.5,0,0,0,1.33-3.79,29.62,29.62,0,0,0-.11-6,49.17,49.17,0,0,1-.32-7.44,14.14,14.14,0,0,1,2.22-7.07,8.31,8.31,0,0,1,2.32-2.3,7.94,7.94,0,0,1,2.62-1.1,6.51,6.51,0,0,1,4.05.3,5.21,5.21,0,0,1,.58.29,2.92,2.92,0,0,1,.39.26,2,2,0,0,1,.3.25,8,8,0,0,0-1.31-.71,6.52,6.52,0,0,0-4-.23,8,8,0,0,0-4.79,3.37,14,14,0,0,0-2.16,7,50.31,50.31,0,0,0,.3,7.4,28.31,28.31,0,0,1,.06,6.08,8.4,8.4,0,0,1-1.43,3.83A4.47,4.47,0,0,1,236.73,192.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.05,192.54a6.81,6.81,0,0,0,1.76-.74,9.69,9.69,0,0,0,3.29-4,18.48,18.48,0,0,0,1.26-3.38,14.3,14.3,0,0,0,.35-4.1c-.06-1.46-.24-3-.32-4.59a22.22,22.22,0,0,1,0-2.45,13.6,13.6,0,0,1,.42-2.5,13,13,0,0,1,5.66-7.52,12.25,12.25,0,0,1,7.53-1.73,12.6,12.6,0,0,1,5,1.51,9.16,9.16,0,0,1,1.6,1.08l-.11-.06-.31-.21a5.92,5.92,0,0,0-.51-.32c-.21-.12-.44-.27-.72-.41a13,13,0,0,0-5-1.42,12.19,12.19,0,0,0-7.4,1.75,12.78,12.78,0,0,0-5.55,7.4,13,13,0,0,0-.41,2.44c-.05.82,0,1.63,0,2.42.08,1.59.26,3.13.31,4.6a14,14,0,0,1-.38,4.16,17.83,17.83,0,0,1-1.3,3.41,9.59,9.59,0,0,1-3.39,4,5.34,5.34,0,0,1-1.32.56l-.36.08C226.09,192.54,226.05,192.55,226.05,192.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.69,188.19a1.13,1.13,0,0,1,0,.12c0,.09,0,.21,0,.35s0,.35,0,.57,0,.49,0,.79a7.83,7.83,0,0,1-.48,2.1,6.77,6.77,0,0,1-1.55,2.43,11.31,11.31,0,0,1-6.9,2.93,21.76,21.76,0,0,1-4.57,0,18.1,18.1,0,0,1-4.83-1.1l-.31-.13.32-.1a17.77,17.77,0,0,0,5-2.45l.08-.05.11.21a16.78,16.78,0,0,1-11.11-.21l-.24-.09.23-.11a20.9,20.9,0,0,0,5.89-4.27,10.49,10.49,0,0,0,2.63-5,10.63,10.63,0,0,0,0-3.71l-.23-1c0-.1,0-.19-.06-.25s0-.09,0-.09l0,.08.07.25c.07.23.15.55.27,1a9.54,9.54,0,0,1-2.54,8.82,20.51,20.51,0,0,1-5.92,4.34v-.2a16.63,16.63,0,0,0,11,.19l.78-.26-.67.47-.08.06a18,18,0,0,1-5,2.48v-.22a17.88,17.88,0,0,0,4.77,1.09,20.59,20.59,0,0,0,4.51,0,11.21,11.21,0,0,0,6.82-2.83,6.82,6.82,0,0,0,1.55-2.36,8.49,8.49,0,0,0,.51-2.07c0-.29,0-.55.05-.78a5.39,5.39,0,0,0,0-.57v-.35A1.09,1.09,0,0,0,243.69,188.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.12,230.2c-.07,0-.44-7.21-.84-16.11s-.66-16.12-.59-16.12.44,7.21.83,16.11S224.19,230.19,224.12,230.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.47,230.79a1.32,1.32,0,0,1-.09-.29c-.06-.22-.13-.5-.21-.85-.19-.73-.43-1.8-.71-3.12-.58-2.65-1.29-6.33-1.93-10.41s-1.09-7.8-1.35-10.49c-.14-1.35-.23-2.44-.29-3.19,0-.36,0-.65,0-.87a1.82,1.82,0,0,1,0-.31,1,1,0,0,1,0,.3c0,.22.06.51.11.87.08.78.21,1.86.36,3.18.3,2.69.78,6.4,1.42,10.48s1.32,7.75,1.85,10.4c.27,1.31.48,2.37.64,3.14.07.35.12.64.16.86A1.31,1.31,0,0,1,231.47,230.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.63,203.61a2.52,2.52,0,0,0-.94-.47h.06a2.43,2.43,0,0,0-2.76.34,2.54,2.54,0,0,0-.76,1.54,2.62,2.62,0,0,0,.29,1.78,2.37,2.37,0,0,0,1.43.95,4.3,4.3,0,0,0,1.75,0,2.58,2.58,0,0,0,1.48-.71,2,2,0,0,0,.45-1.24A2.71,2.71,0,0,0,261.63,203.61Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.87,206.24s0-.13,0-.31a.89.89,0,0,0-.41-.6,3,3,0,0,0-1.19-.17,5,5,0,0,0-1.53.23,12.52,12.52,0,0,0-2.69,1.07c-.7.31-1.17.41-1.19.35s.39-.29,1-.68a9.2,9.2,0,0,1,2.73-1.25c.29-.07.54-.13.85-.18a5.75,5.75,0,0,1,.82,0,2.81,2.81,0,0,1,1.39.35,1,1,0,0,1,.4.91C263,206.19,262.89,206.26,262.87,206.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.72,291.44s12.25-1.8,15.27-.62,18.28,8.55,20,11.74,5.7,8.89,6.21,11.74,1,11.4,1,11.4a4,4,0,0,1-3.86-3.85l-1.17,3.85s-3.19.84-3.69-1.34c0,0-1.85,2.35-2.68-3a56.56,56.56,0,0,1-.84-7l-2.52-3.69,1.34,4.93-.67,7.48s-2.68,0-2.85-2.35a23.1,23.1,0,0,0-1.17-5.13l-3.36-5.27s-8.48-4.42-10.38-6.54a10.23,10.23,0,0,1-2.11-2.88l-8.37,2.79Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.81,325.89a3,3,0,0,1-1.58-.37,1.71,1.71,0,0,1-.8-1.1,1.24,1.24,0,0,1-1.11.45c-.72-.19-1.25-1.37-1.59-3.52a59.26,59.26,0,0,1-.84-7l-2.43-3.56,1.31,4.78h0l-.68,7.51h0s-2.71,0-2.88-2.37a22.7,22.7,0,0,0-1.17-5.13l-3.35-5.26c-.26-.14-8.52-4.46-10.37-6.54a11.18,11.18,0,0,1-2.12-2.86l-8.37,2.79v0l-.11-12.22h0c.12,0,12.29-1.78,15.28-.62,1.53.6,6.14,2.76,10.48,5.12,3.83,2.08,8.59,4.92,9.49,6.64.53,1,1.29,2.25,2.1,3.58,1.76,2.91,3.76,6.2,4.11,8.17.5,2.82,1,11.32,1,11.4v0h0a4.26,4.26,0,0,1-1.75-.48A4.18,4.18,0,0,1,321.3,322l-1.15,3.77h0A6,6,0,0,1,318.81,325.89Zm-2.36-1.58v.05a1.75,1.75,0,0,0,.8,1.12,4.35,4.35,0,0,0,2.85.2l1.2-3.95,0,.11a4,4,0,0,0,3.81,3.84c0-.53-.53-8.64-1-11.38-.34-1.95-2.34-5.24-4.11-8.15-.8-1.32-1.57-2.58-2.09-3.58s-2.54-2.86-9.47-6.62c-4.34-2.35-8.95-4.52-10.48-5.11-2.92-1.14-14.65.54-15.23.62l.11,12.15,8.35-2.79v0a10.86,10.86,0,0,0,2.11,2.86c1.87,2.1,10.29,6.5,10.37,6.54h0l3.36,5.26a23.72,23.72,0,0,1,1.18,5.15c.15,2.18,2.54,2.32,2.8,2.33l.67-7.46-1.38-5.07,2.6,3.82h0a57.51,57.51,0,0,0,.84,7c.41,2.65,1.08,3.36,1.56,3.49l.18,0a1.36,1.36,0,0,0,.9-.5Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.62,
    y: 290.42,
    width: 3.49,
    height: 11.95,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.25,
    y: 288.07,
    width: 8.22,
    height: 2.35,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.81,221.93s-4,1.93-4,5.09-.67,28.79-.67,28.79l14.45-8.12-2.35-17,15.63-9.58s3-5.33,2.71-7-3.38-4.92-4.9-4.75a3.51,3.51,0,0,0-2.35,1.51l-4.71,1s.34,3,2.36,2.86l1.34-.17-.17,1.17-2.35,1.69Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.81,221.93l.25-.1.75-.25,2.92-.93,11-3.41-.05,0,2.35-1.69-.07.12c.05-.36.1-.77.16-1.18l.2.21-1.3.17a1.89,1.89,0,0,1-1.4-.41,4.25,4.25,0,0,1-1.22-2.61l0-.18.19,0,4.71-1-.14.1a3.82,3.82,0,0,1,1.62-1.38,2.61,2.61,0,0,1,1.1-.24,2.46,2.46,0,0,1,1.08.35,9.78,9.78,0,0,1,3.15,3.06,5.77,5.77,0,0,1,.55,1,2.18,2.18,0,0,1,.16,1.21,9.82,9.82,0,0,1-.66,2.24,37.65,37.65,0,0,1-2.07,4.24l0,.05,0,0-15.63,9.59.12-.26c.08.54.16,1.12.24,1.7.73,5.28,1.44,10.41,2.11,15.31l0,.17-.15.09L248.23,256l-.36.2v-.4c.29-10.62.53-19.5.69-25.77,0-.78.05-1.52.07-2.22a7.4,7.4,0,0,1,.21-2,6,6,0,0,1,1.8-2.52,8,8,0,0,1,2.16-1.4s0,0-.14.1l-.41.25a10.22,10.22,0,0,0-1.52,1.16,5.86,5.86,0,0,0-1.69,2.48,7.11,7.11,0,0,0-.17,1.9c0,.7,0,1.44,0,2.22-.12,6.27-.29,15.16-.5,25.78l-.34-.21,14.44-8.15-.13.26c-.68-4.9-1.39-10-2.13-15.31-.08-.58-.16-1.16-.23-1.7l0-.17.14-.09,15.64-9.57-.09.09a37.38,37.38,0,0,0,2.05-4.17,8.91,8.91,0,0,0,.63-2.11,2.78,2.78,0,0,0-.62-1.92,9.64,9.64,0,0,0-3-2.92,2,2,0,0,0-.88-.29,2.08,2.08,0,0,0-.9.19,3.59,3.59,0,0,0-1.44,1.2l-.05.08-.08,0-4.71,1,.16-.22a3.83,3.83,0,0,0,1.06,2.36,1.48,1.48,0,0,0,1.11.32l1.3-.15.24,0,0,.23c-.06.42-.12.82-.17,1.18v.08l-.06,0-2.36,1.67,0,0h0l-11,3.27-3,.85-.76.21Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.22,218.92c-.05-.06.43-.49,1.13-1.24a6.09,6.09,0,0,0,1-1.44,3.79,3.79,0,0,0,.3-2.05,10.38,10.38,0,0,0-.4-2.12,1.22,1.22,0,0,0-1.22-.81,5.77,5.77,0,0,1-1.25-.13c-.3-.1-.41-.24-.4-.26s.17,0,.44.06a11.68,11.68,0,0,0,1.22,0,2,2,0,0,1,.92.17,1.63,1.63,0,0,1,.74.83,9,9,0,0,1,.47,2.26,4.06,4.06,0,0,1-.39,2.31,5.44,5.44,0,0,1-1.18,1.48A4.06,4.06,0,0,1,272.22,218.92Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.52,335c-6.07-8-18.94-8.7-25.54-1.09a13.83,13.83,0,0,0-3.44,9.39c0,15.8,8.52,58.49,10.39,71,2,13.4,7.56,36.33,7.56,36.33l27.29-3.87s-10.24-80.22-11.51-89.62-3.22-17.47-3.22-17.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.26,320.58c.84-.56,39-14.76,45.68-16.15s12.89-2.15,20.37,4.79c9.14,8.46,25.8,109.79,25.8,109.79S291,423.78,291,423.22s-19.26-83-19.26-83L237.87,361.9l-18.85-28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.84,372.6a1,1,0,0,1-.07-.25c0-.2-.08-.45-.14-.76-.11-.71-.27-1.68-.47-2.92-.39-2.58-.93-6.24-1.61-10.75S276,348,274.5,342.11A29.57,29.57,0,0,0,271,333.4a16.16,16.16,0,0,0-7.53-6.41,14.14,14.14,0,0,0-9.83,0,16.48,16.48,0,0,0-7.55,5.35,14.9,14.9,0,0,0-2.61,8c-.17,2.67-.06,5.2,0,7.48.28,4.56.93,8.24,1.12,10.8.11,1.28.16,2.28.18,2.95v.77a1.1,1.1,0,0,1,0,.27,1.1,1.1,0,0,1,0-.27c0-.21,0-.46-.06-.77-.05-.67-.13-1.67-.27-2.94-.25-2.55-1-6.2-1.29-10.8a74.37,74.37,0,0,1-.07-7.53,15.25,15.25,0,0,1,2.66-8.21,16.81,16.81,0,0,1,7.76-5.54,14.64,14.64,0,0,1,10.19,0,16.7,16.7,0,0,1,7.77,6.63A29.82,29.82,0,0,1,275,342c1.45,5.91,2.29,11.32,2.95,15.86s1.09,8.19,1.44,10.78c.16,1.24.29,2.22.38,2.93,0,.31.06.57.08.77A1,1,0,0,1,279.84,372.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.27,309.91a1.93,1.93,0,0,1-.44.22l-1.32.54c-1.14.47-2.81,1.11-4.88,1.9-4.12,1.57-9.86,3.67-16.18,6s-12,4.47-16.14,6.11l-4.85,1.95-1.32.53a1.87,1.87,0,0,1-.48.15s.14-.1.43-.25l1.29-.61c1.12-.53,2.75-1.26,4.79-2.11,4.07-1.73,9.76-3.94,16.1-6.26s12.08-4.36,16.24-5.85l4.93-1.74,1.35-.45A1.5,1.5,0,0,1,256.27,309.91Z",
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.6aa12fee4917bef7425f0d61fcc2f548.svg";
export { ForwardRef as ReactComponent };